import type { TFunction } from 'i18next'
import type { RemovalBlocker } from '@/lib/api/pipelines.ts'

/**
 * A blocker in the operator's words. The kind arrives as a plain string so a
 * kind the engine adds later renders as a row rather than blanking the list —
 * that unknown one falls through to its own line, naming the kind, because
 * "something is in the way and we will not say what" is the worse answer.
 */
export function blockerLabel(t: TFunction, blocker: RemovalBlocker): string {
  switch (blocker.kind) {
    case 'cards':
      return t('pages.pipelines.removal.blockers.cards', {
        count: blocker.count,
        defaultValue: 'It holds {{count}} card(s) — deleting would destroy the only copy.',
      })
    case 'audit':
      return t('pages.pipelines.removal.blockers.audit', {
        count: blocker.count,
        defaultValue: '{{count}} audit(s) name this board in their period.',
      })
    case 'flow':
      return t('pages.pipelines.removal.blockers.flow', {
        count: blocker.count,
        defaultValue: '{{count}} flow(s) belong to it or write into it.',
      })
    case 'identity':
      return t('pages.pipelines.removal.blockers.identity', {
        count: blocker.count,
        defaultValue: '{{count}} customer identifier(s) came from this board.',
      })
    case 'sync_run':
      return t('pages.pipelines.removal.blockers.syncRun', {
        count: blocker.count,
        defaultValue: 'A synchronisation run is still in flight.',
      })
    default:
      return t('pages.pipelines.removal.blockers.unknown', {
        kind: blocker.kind,
        count: blocker.count,
        defaultValue: '{{count}} record(s) of kind “{{kind}}” still reference it.',
      })
  }
}
